<template>
    <div class="container">
        <div class="page-content">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading">
                        <img src="/assets/dipocaco/pocas/shop.png" alt="shop-poca" class="page-poca">
                        Decks
                    </h1>
                </div>

                <div class="col-12 mt-2">
                    <a href="javascript:" class="btn btn-sm btn-success">Create new deck</a>
                </div>

                <router-link v-for="deck in decks" :to="{ name: 'deck-builder', params: { user_deck_id: deck.id }}" class="col-4 mt-2">
                    {{ deck.name }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Decks",
    data() {
        return {
            decks: []
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchUserDecks();
    },
    computed: {
    },
    watch: {
    },
    methods: {
        async fetchUserDecks() {
            this.decks = await fetch("/api/user-decks").then(res => res.json());
        }
    },
};
</script>

<style scoped lang="scss">
.page-heading {
    background-image: url("/assets/dipocaco/pocas/decks-poca_sm.jpg");
    background-position: center 45%;
}
</style>
